<template>
  <v-app id="inspire">
    <v-row
      class="pa-0 ma-0"
      :style="{backgroundColor: $theme.options.toolbar.color, maxHeight: '60px'}"
    >
      <v-col class="d-flex px-5 align-center">
        <ImagemComFallback
          max-width="80"
          :src="$theme.logoHome"
          contain
          srcDefault="/assets/imgs/logo.svg"
        />
      </v-col>
    </v-row>
    <v-main>
      <v-container
        id="layout-main-container"
        fluid
        style="height: 100%"
        class="pa-0 ma-0 align-center d-flex"
        justify="center"
      >
        <v-row no-gutters class="pa-0">
          <v-col cols="12" class="justify-center d-flex">
            <v-card
              color="#FFFFFF"
              flat
              class="rounded-xl px-4 py-6"
              style="max-width: 1416px"
            >
              <v-row>
                <v-col cols="5">
                  <v-img
                    src="../assets/imgs/cadasto-nova-senha.svg"
                    width="100%"
                    height="100%"
                  />
                </v-col>
                <v-col cols="7" class="pl-9 d-flex flex-column justify-center">
                  <div style="max-width: 550px" class="pl-9">
                    <core-form ref="form" v-show="!msgResetError && validToken" :submit="enviarSenha">
                      <v-row class="mb-9">
                        <span class="text-title">Cadastro de nova senha</span>
                      </v-row>
                      <span> Insira uma nova senha abaixo. </span>
                      <v-row class="pa-0 pt-4">
                        <v-col cols="8" class="pl-0 pb-0">
                          <input-password
                            v-model="model.NovaSenha"
                            label="Nova senha"
                            name="Senha"
                            @input="validarSenha"
                            required
                          />
                        </v-col>
                        <v-col cols="8" class="pl-0 pb-0">
                          <input-password
                            v-model="confirmacaoNovaSenha"
                            label="Confirme sua senha"
                            name="Confirmação de senha"
                            required
                            :rules="[mesmaSenha ||'Senhas não correspondem']"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="pa-0 my-0">
                          <ul>
                            <li v-for="(validation, key) in validations" :key="key" class="li-validar-senha">
                              <v-icon v-if="validation.test" color="green" class="pr-2">mdi-check-circle</v-icon>
                              <v-icon v-else color="red" class="pr-2">mdi-close-circle</v-icon>
                              <span>{{ validation.message }}</span>
                            </li>
                          </ul>
                        </v-col>
                      </v-row>
                      <v-row class="pl-0">
                        <v-col cols="8" class="pl-0">
                          <div class="d-flex justify-end">
                            <v-btn
                              type="submit"
                              color="primary"
                              elevation="0"
                              :disabled="!(mesmaSenha && senhaValida)">
                              Continuar
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </core-form>

                    <v-col cols="12" v-show="msgResetError">
                    <v-alert type="error" class="mt-3" text>
                      {{ msgResetError }}
                    </v-alert>
                    <br />
                    <v-btn
                      @click="redirectLembrar"
                      color="primary"
                      elevation="0">
                      Recuperação de Senha
                    </v-btn>
                  </v-col>
                  </div>
                </v-col>
              </v-row>
            </v-card>
            <v-dialog v-if="showDialogSucess" v-model="showDialogSucess" max-width="400" persistent>
              <v-card>
                <v-card-text class="pt-6 pb-1">
                  <v-row>
                    <v-col cols="12" class="d-flex justify-center">
                      <span class="text-title-senha">Cadastro de senha</span>
                    </v-col>
                    <v-col>
                      <v-img
                        src="../assets/imgs/cadasto-nova-senha-success.svg"
                        height="83"
                        contain
                      />
                    </v-col>
                    <v-col cols="12" class="d-flex justify-center">
                      <span class="text-center text-body-senha">
                        Sua senha foi cadastrada com sucesso. Agora você pode acessar sua conta com a nova senha.
                      </span>
                    </v-col>
                  </v-row>
                </v-card-text>
                <div class="py-4 px-4">
                  <v-divider />
                </div>
                <v-card-actions class="py-4 d-flex justify-center">
                  <v-btn color="primary" elevation="0" @click="redirecionarLogin">
                    Ok
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-if="showDialogError" v-model="showDialogError" max-width="400" persistent>
              <v-card>
                <v-card-text class="pt-6 pb-1">
                  <v-row>
                    <v-col cols="12" class="d-flex justify-center">
                      <span class="text-title-senha">Atenção!</span>
                    </v-col>
                    <v-col>
                      <v-img
                        src="../assets/imgs/cadasto-nova-senha-success.svg"
                        height="83"
                        contain
                      />
                    </v-col>
                    <div class="text-body-senha">
                      <v-col cols="12" class="d-flex py-0">
                        <span class="py-0">
                          Senha não pode conter:
                        </span>
                      </v-col>
                      <v-col class="py-0">
                        <ul style="text-align: left">
                          <li v-for="(regra, index) in regrasDeSenha" :key="index">
                            {{ regra }}
                          </li>
                        </ul>
                      </v-col>
                    </div>
                  </v-row>
                </v-card-text>
                <div class="py-4 px-4">
                  <v-divider />
                </div>
                <v-card-actions class="py-4 d-flex justify-center">
                  <v-btn color="primary" elevation="0" @click="showDialogError = false">
                    Ok
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
export default {
  data () {
    return {
      model: { NovaSenha: '', Login: '', Token: '' },
      confirmacaoNovaSenha: '',
      validToken: false,
      showDialogSucess: false,
      showDialogError: false,
      msgResetError: '',
      validations: {
        caractereEspecial: { test: false, message: '1 caractere especial' },
        letraMaiuscula: { test: false, message: '1 letra maiúscula' },
        letraMinuscula: { test: false, message: '1 letra minúscula' },
        numero: { test: false, message: '1 número' },
        caracteresUnicos: { test: false, message: '4 caracteres únicos' },
        extensaoMinima: { test: false, message: '8 caracteres no mínimo' }
      },
      regrasDeSenha: [
        'Documento Federal, ou partes dele',
        'Telefone, ou partes dele',
        'Data de nascimento, ou partes dela',
        'Sequências frágeis: abc, 1234, qwerty, entre outras',
        'Não pode ser igual a senhas usadas nos últimos 12 meses'
      ],
    };
  },
  methods: {
    redirecionarLogin () {
      this.$router.push('/partner/:parceiro');
    },
    redirectLembrar () {
      this.$router.push('/lembrar')
    },
    enviarSenha () {
      const th = this;
      th.$api.Autenticacao.RecuperarSenhaOnboarding(th.model).then(function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          th.showDialogSucess = true;
        } else {
          th.showDialogError = true;
        }
      }).catch((err) => console.error(err));
    },
    validarSenha (senha) {
      const th = this;
      // eslint-disable-next-line
      const regexCaractereEspecial = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      const regexLetraMaiuscula = /\p{Lu}/u;
      const regexLetraMinuscula = /[\p{Ll}]/u;
      const regexNumero = /[0-9]/;
      const regexCaracteresUnicos = /^.*(?:(.)(?!.*\1)){4}/;

      th.validations.caractereEspecial.test = regexCaractereEspecial.test(senha);
      th.validations.letraMaiuscula.test = regexLetraMaiuscula.test(senha);
      th.validations.letraMinuscula.test = regexLetraMinuscula.test(senha);
      th.validations.numero.test = regexNumero.test(senha);
      th.validations.caracteresUnicos.test = regexCaracteresUnicos.test(senha);
      th.validations.extensaoMinima.test = senha.length >= 8;
    },
    validarToken () {
      const th = this;
      th.$api.Autenticacao.ValidaTokenSenha(th.model.Login, th.model.Token
      ).then(function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          th.validToken = true;
        } else {
          th.msgResetError = 'O link para recuperação de senha expirou, é possível solicitar um novo link a partir da recuperação de senha'
        }
      })
    },
  },
  computed: {
    senhaValida () {
      const th = this;
      return Object.values(th.validations).every(validation => validation.test);
    },
    mesmaSenha () {
      const th = this;
      return th.model.NovaSenha === th.confirmacaoNovaSenha;
    },
  },
  async mounted () {
    if (this.$route.query.p) {
      const paramsResponse = await this.$api.Autenticacao.RefreshParametros(this.$route.query.p)
      if (paramsResponse.success) {
        const params = paramsResponse.response;
        this.model.Token = params.token;
        this.model.Login = params.usuario;
        if (params.token) {
          this.validarToken();
        }
      }
    }
  }
};
</script>

<style scoped>
.text-title {
  color: var(--v-primary-base);
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.text-body {
  color: #3a3939;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}
.text-title-senha {
  color: #3a3939;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
.text-body-senha {
  color: #202020;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
}
.underline {
  text-decoration-line: underline;
}
.li-validar-senha {
  list-style-type: none;
  height: 34px;
}
</style>
